import { FTM_ITEMS, FTM_DIMS } from "./questionBank.js";
import { scoreFTM, FTM_NORMS, FTM_BANDS, FTM_DIM_THRESHOLDS, FTM_RISK_FLAGS } from "./scoring.js";
export { FTM_DIMS, FTM_NORMS, FTM_BANDS, FTM_DIM_THRESHOLDS, FTM_RISK_FLAGS };

const FirstTimeManagerTransition = {
  id:"ftm", name:"First-Time Manager Transition Assessment", shortName:"FTM Transition",
  icon:"🪜", color:"#1d4ed8", bg:"#eff6ff",
  description:"30-item diagnostic measuring readiness for the specific psychological and behavioural transition from individual contributor to first-time manager. Grounded in Hill's (1992/2003) identity-transition research, Watkins' (2003) First 90 Days, and CCL first-time-manager failure studies. Measures Letting Go of Doing, Delegation Confidence, Managing Former Peers, Giving Difficult Feedback, Strategic Time Allocation and Building Managerial Authority.",
  desc:"30 items · 10 minutes · Transition Readiness Index · Risk flag diagnosis",
  publisher:"AXIS360 Enterprise", version:"1.0",
  itemCount:36, items:36, timeLimit:10, time:"10 min", timeEstimate:"10 minutes",
  format:"likert_0_4", scaleType:"likert-5", isScreener:false, pricingTier:"enterprise", creditCost:20,
  pagesOf:30, totalPages:2, scaleMin:0, scaleMax:4,
  scale:{ min:0, max:4, labels:["Strongly Disagree","Disagree","Neutral","Agree","Strongly Agree"] },
  scaleLabels:["Strongly Disagree","Disagree","Neutral","Agree","Strongly Agree"],
  predicts:["First-time manager retention and success in first 18 months","Team engagement under new management","Delegation and micromanagement risk","Speed of transition to full managerial effectiveness"],
  questions: FTM_ITEMS,
  dims: FTM_DIMS,
  score(answers){ return scoreFTM(answers); },
  nineboxAxes:{ x:{label:"Transition Readiness",scaleIds:["ftm"]}, y:{label:"Transition Readiness",scaleIds:["ftm"]} },
};
export default FirstTimeManagerTransition;
